// extracted by mini-css-extract-plugin
export default {"label":"Participants_label__5OSEV"};